export enum DrawerNewsLetter {
    Edit = 'Edit NewsLetter',
    Create = 'Create NewsLetter',
}
export interface INewsLetter {
    id: number;
    title: string;
    heading: string;
    description1: string;
    description2: string;
    location: string;
    img: string | null ;
    pdf: string | null ;
    createdAt: string;
    updatedAt: string;
    deletedAt: null | string;
}
export interface INewsLetterDto {
    title: string;
    heading: string;
    description1: string;
    description2: string;
    location: string;
    img: string | null |File;
    pdf: string | null |File;
}